import { ShopSystemConfiguration } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationModel'
import { QntmConfiguration, QntmSystemConfiguration } from 'src/State/ShopQntmSystemConfiguration/ShopQntmSystemConfigurationModel'
import { DesiredShippingDate, LineItem } from '../models'
import { ProductGeneralType } from '../types'
import { UnitTypes } from 'src/Libs/types'

export const currencyFormatter = (price: number | undefined, minimumFractionDigits?: number): string => {
  const fractionDigits = minimumFractionDigits ?? 2
  if (price) {
    return `${price.toLocaleString(undefined, { minimumFractionDigits: fractionDigits })} ${UnitTypes.euros}`
  }
  return `0 ${UnitTypes.euros}`
}
/*
 * This function formats the Normal Configurator from Endpoint to expected JSON on configurator state
 */
export const formatSystemConfigurationFromCart = (desiredShippingDate: DesiredShippingDate, lineItem: LineItem): ShopSystemConfiguration => {
  return {
    type: ProductGeneralType.SYSTEM_CONFIGURATOR,
    quantity: lineItem.quantity,
    label: lineItem.label,
    desiredShippingDate: {
      year: desiredShippingDate.year,
      month: desiredShippingDate.month != null ? desiredShippingDate.month - 1 : null,
      day: desiredShippingDate.day,
    },
    configuration: {
      configuratorId: lineItem.payload.configuration?.configuratorId ?? '',
      components: lineItem.payload.configuration?.components ?? [],
      powerMeters: lineItem.payload.configuration?.powerMeters ?? [],
      retrofitBattery: lineItem.payload.configuration?.retrofitBattery ?? null,
      smartMeter: lineItem.payload.configuration?.smartMeter ?? null,
    },
  }
}

/*
 * This function formats the Quantum Configurator from Endpoint to expected JSON on configurator state
 */
export const formatQntmSystemConfigurationFromCart = (desiredShippingDate: DesiredShippingDate, lineItem: LineItem): QntmSystemConfiguration => {
  const configuration = lineItem.payload?.configuration as QntmConfiguration | undefined

  return {
    type: ProductGeneralType.QNTM_SYSTEM_CONFIGURATOR,
    quantity: lineItem.quantity,
    label: lineItem.label,
    desiredShippingDate: {
      year: desiredShippingDate.year,
      month: desiredShippingDate.month != null ? desiredShippingDate.month - 1 : null,
      day: desiredShippingDate.day,
    },
    configuration: {
      configuratorId: configuration?.configuratorId ?? '',
      components: configuration?.components ?? [],
      warrantyExtension: configuration?.warrantyExtension ?? null,
    },
  }
}
